export class SpringConfigs {
    static appearStiffness = 100;
    static appearDamping = 15;
    static exitStiffness = 180;
    static exitDamping = 10;
    static moveStiffness = 150;
    static moveDamping = 10;
    static staggerSpeed = 0.001;
}
